/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';
// current Quarter
const currentDate = new Date();
const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
const currentYear = currentDate.getFullYear();
const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter

const formattedQuarter = `${currentQuarter}Q${currentYear.toString()}`;

const initialState = {
  performResolutionObj: {},
  startQtr: '', // formattedQuarter,
  planType: [],
  rebateProgram: [],
  errorMsgAdjust: [],
  rebateProgramName: {},
  adjustmentData: [],
  rebateGroup: [],
  rebateGroupName: {},
  listRebateGroup: [],
  rebateCategoryValue: '',
  rebateGroupCategoryValue: '',
  selectedOptionValue: 'Single',
  finalGroupByQtr: [],
  displayObj: {
    startQtr: '', // formattedQuarter,
    rebateProgramName: {},
    groupOfRebateProgramList: [],
    rebateGroupCategoryValue: '',
    adjustmentData: [],
    selectedOptionValue: 'Single',
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_ADJUST:
      return { ...state, performResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_ADJUST:
      return { ...state, resolutionDetailObj: action.detailScrData };

    case actionTypes.GET_ERROR_MSG_ADJUST:
      return { ...state, errorMsgAdjust: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_ADJUST:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_ADJUST:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_FROM_ADJUST:
      return { ...state, ...action.payload };
    case actionTypes.SELECT_OPTION:
      return { ...state, ...action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_ADJUST:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_ADJUST:
      const tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_CMS_ADJUSTMENT_DATA:
      const displayObj = {
        ...state.displayObj,
        adjustmentData: action.payload,
      };
      return { ...state, adjustmentData: action.payload, displayObj };

    case actionTypes.GET_CMS_REBATE_GROUP:
      return { ...state, rebateGroup: action.payload };
    case actionTypes.GET_CMS_REBATE_GROUP_NAME:
      return { ...state, ...action.payload };
    case actionTypes.GET_CMS_LIST_REBATE_GROUP:
      return { ...state, listRebateGroup: action.payload };

    case actionTypes.GET_CMS_LIST_REBATE_GROUP_NAME:
      return { ...state, ...action.payload };
    case actionTypes.GROUP_BY_QTR_DATA:
      if (action.payload.length != 0) {
        return {
          ...state,
          finalGroupByQtr: [...state.finalGroupByQtr, ...action.payload],
        };
      }
      return { ...state, finalGroupByQtr: action.payload };

    case actionTypes.SET_REFRESH_DATA_ADJUSTMENT_CMS:
      return {
        ...state,
        performResolutionObj: {},
        startQtr: formattedQuarter,
        planType: [],
        rebateProgram: [],
        errorMsgAdjust: [],
        rebateProgramName: {},
        adjustmentData: [],
        rebateGroup: [],
        rebateGroupName: {},
        listRebateGroup: [],
        rebateCategoryValue: '',
        rebateGroupCategoryValue: '',
        selectedOptionValue: 'Single',
      };
    case actionTypes.SET_REFRESH_DATA_ADJUSTMENT_CMS_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
